<div
  class="card"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle=".card-header"
>
  <div class="card-header dialog-drag-handle">
    <span class="card-title">Execute Selected Training Actions</span>
    <button mat-mini-fab class="closex" color="warn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="card-body">
    <div class="mat-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="procedure">
          <th mat-header-cell class="px-2" *matHeaderCellDef>
            <span>Procedure</span>
          </th>
          <td mat-cell class="px-2" *matCellDef="let a">
            <span
              class="bold blue"
              [innerHTML]="a.procedure.procedureNumber"
            ></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell class="px-2" *matHeaderCellDef>
            <span>Title</span>
          </th>
          <td mat-cell class="px-2" *matCellDef="let a">
            {{ a.procedure.title }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell class="px-2" *matHeaderCellDef>
            <span>Credit Date</span>
          </th>
          <td mat-cell class="px-2" *matCellDef="let a">
            <mat-form-field
              class="no-subscript mt-1"
              *ngIf="a.canApprove || a.canCompleteAndApprove"
            >
              <input
                matInput
                [matDatepicker]="picker"
                [(ngModel)]="a.procedureTrainingCredited.creditDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell class="px-2" *matHeaderCellDef>
            <span>Action</span>
          </th>
          <td mat-cell class="px-2" *matCellDef="let a" class="bold">
            <span class="d-flex align-items-center">
              {{ a.action }}
              <mat-icon class="green ml-2" *ngIf="a.done"
                >check_circle</mat-icon
              >
              <mat-icon
                class="ml-2"
                *ngIf="a.action == 'Error' || a.action == 'Warning'"
                [ngClass]="{
                  red: a.action == 'Error',
                  yellow: a.action == 'Warning',
                }"
                [matTooltip]="a.toolTip"
                >error</mat-icon
              >
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-stroked-button color="warn" (click)="close()">Close</button>
      <button mat-flat-button color="primary" *ngIf="!done" (click)="confirm()">
        Confirm
      </button>
    </div>
  </div>
</div>
